export const CHAT_MAX_MESSAGE_LENGTH = 200

export const CHAT_SUGGESTED_QUESTIONS = [
  'Хүргэлтийн хугацаа',
  'Захиалга хянах',
  'Хямдралтай бараанууд',
  'Салбарын мэдээлэл',
]

export type ChatPaymentOption = { key: string, label: string, chatLabel: string }

export const CHAT_PAYMENT_OPTIONS: ChatPaymentOption[] = [
  { key: 'qpay', label: 'QPay', chatLabel: 'QPay-ээр төлөх' },
  { key: 'transfer', label: 'Дансаар', chatLabel: 'Дансаар шилжүүлэх' },
  { key: 'storepay', label: 'StorePay', chatLabel: 'Storepay-ээр төлөх' },
  { key: 'pocket', label: 'Pocket', chatLabel: 'Pocket-оор төлөх' },
  { key: 'lend', label: 'LendMN', chatLabel: 'LendMN-ээр төлөх' },
  { key: 'omniway', label: 'OmniWay', chatLabel: 'OmniWay-ээр төлөх' },
]

export const CHAT_PAYMENT_LABELS: Record<string, string> = {
  qpay: '💳 QPay-ээр төлөх',
  transfer: '🏦 Шилжүүлэг хийх',
  storepay: '📱 Storepay төлөх',
  pocket: '💳 Pocket Zero төлөх',
  lend: '📱 LendMN төлөх',
  omniway: '📱 OmniWay төлөх',
  simple: '📦 Захиалга харах',
}

export const CHAT_MIN_AMOUNT_METHODS = ['storepay', 'pocket', 'lend', 'omniway']

export type ParsedChatContent = { type: string, message?: string, metadata: any } | null

export function parseChatMessageContent(message: string): ParsedChatContent {
  try {
    const parsed = JSON.parse(message)
    if (parsed.type && parsed.metadata) return parsed
    return null
  } catch {
    return null
  }
}

export type ChatProductDisplay = {
  hasMultipleVariants: boolean
  selectedVariantId: string | undefined
  selectedVariant: any
  displayHasDiscount: boolean
  displayImage: string
  displayStock: number
  displayName: string
  isTrackable: boolean
  isInStock: boolean
}

export function getChatProductDisplay(product: any, overrideVariantId?: string): ChatProductDisplay {
  const variants = product?.variants || []
  const hasMultipleVariants = variants.length > 1
  const firstAvailableVariant = variants.length > 0 ? variants[0] : null
  const selectedVariantId = overrideVariantId || firstAvailableVariant?.id
  const selectedVariant = variants.find((v: any) => v.id === selectedVariantId) || firstAvailableVariant
  const displayHasDiscount = selectedVariant?.hasDiscount ?? product?.hasDiscount ?? false
  const displayImage = selectedVariant?.images?.[0] || product?.image || 'placeholder.png'
  const displayStock = selectedVariant?.stock ?? 0
  const displayName = selectedVariant?.name || 'Үндсэн төрөл'
  const isTrackable = !!product?.isTrackable
  const isInStock = isTrackable ? displayStock > 0 : !!product?.inStock
  return { hasMultipleVariants, selectedVariantId, selectedVariant, displayHasDiscount, displayImage, displayStock, displayName, isTrackable, isInStock }
}

export function getChatAlternativePayments(metadata: any, configMethods: string[] = ['transfer']): ChatPaymentOption[] {
  if (!metadata?.showPaymentChange || metadata?.paymentMethod === 'simple') return []
  return CHAT_PAYMENT_OPTIONS.filter(p =>
    p.key !== metadata.paymentMethod
    && configMethods.includes(p.key)
    && !(CHAT_MIN_AMOUNT_METHODS.includes(p.key) && metadata.amount < 100000)
  )
}
